<div class="upsell-card" *transloco="let t; read: 'branding-upsell-card'">
  <div class="left">
    <div class="title-and-chip">
      <div class="font-xxl-semibold">
        {{ t(package() + '.title') }}
      </div>

      <ng-content select="[chipTemplate]"></ng-content>
    </div>

    <div class="font-normal-regular">{{ t(package() + '.description') }}</div>

    <div class="cta">
      <ng-content select="[ctaTemplate]"></ng-content>
    </div>
  </div>

  <div class="right">
    <img [ngSrc]="image[package()]" alt="" width="170" height="170" />
  </div>
</div>
